export const FETCH_MENU_TOPO    = 'FETCH_MENU_TOPO';
export const FETCH_SUB_MENU     = 'FETCH_SUB_MENU';
export const FETCH_CHECK_SELECT = 'FETCH_CHECK_SELECT';
export const ACTION_MOAL        = 'ACTION_MOAL';
export const ACTION_TOPO        = 'ACTION_TOPO';
export const ACTION_BG          = 'ACTION_BG';


// inicio
export function GetListaMenuTopo(lista){

   return{
        type    : FETCH_MENU_TOPO,
        payload : lista
    };
}


export function GetListaSubMenuTopo(lista){

    return{
         type    : FETCH_SUB_MENU,
         payload : lista
     };
 }

 export function GetCheckSelect(select){
    return{
         type    : FETCH_CHECK_SELECT,
         payload : select
     };
 }


 export function ActionModal(acao){
	
    return {
          type    : ACTION_MOAL,
          payload : acao
     }
}

export function GetActionTopo(acao){
	
    return {
          type    : ACTION_TOPO,
          payload : acao
     }
}

export function GetActionBg(acao){
	
    return {
          type    : ACTION_BG,
          payload : acao
     }
}

export function GetColorUser(nome){
    return dispatch => {

        var hexadecimais = '0123456789ABCDEF';
        var cor = '#';
    
        // Pega um número aleatório no array acima
        for (var i = 0; i < 6; i++ ) {
        //E concatena à variável cor
            cor += hexadecimais[Math.floor(Math.random() * 16)];
        }

        const primeiraString = nome.charAt(nome.length1);
        const ultimaString   = nome.charAt(nome.length-1);

        return {color:cor,nome:`${primeiraString}${ultimaString}`}

    }

}

export function PaginateElement(array, page_size, page_number){
    return dispatch => {
    --page_number; // because pages logically start with 1, but technically with 0
    return {itens:array.slice(page_number * page_size, (page_number + 1) * page_size)};
}
}





// WEBPACK FOOTER //
// ./src/actions/scopoAction.js